export function videoLoader() {
	const video = document.querySelector('#js-video-load');
	const play = document.querySelector('.video-play');
	const fullscreenButton = document.querySelector('.full-screen');

	window.addEventListener('load', () => {
		if (video) {
			if (play) {
				play.addEventListener('click', () => {
					playVid();
				});

				video.addEventListener('click', () => {
					playVid();
				});
			}

			if (fullscreenButton) {
				fullscreenButton.addEventListener('click', function() {
					if (video.webkitSupportsFullscreen) {
						video.webkitEnterFullscreen();
						return;
					}

					video.requestFullscreen();
				});

				document.addEventListener('fullscreenchange', function() {
					if (document.fullscreenElement) {
						video.setAttribute('controls', true);
						return;
					}

					video.removeAttribute('controls');
				});
			}
		}
	}, false);

	function playVid() {
		video.style.display = 'block';
		fullscreenButton.style.display = 'block';

		if (video.paused) {
			video.play();
			play.style.opacity = 0;
			play.classList.add('pause');
		} else {
			video.pause();
			play.style.opacity = 1;
			play.classList.remove('pause');
		}
	}
}
